export default __webpack_public_path__ + "static/media/header-2.90b4dc3d.jpg";